const B_1 = [
    {
        title: '评标准备',
        path: '/bidding/projectflow/ping/pbzb/list'
    }
]
export default {
    path: 'pbzb',
    component: () => import(/*webpackChunkName: 'bidding-ping-getoffer'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import('@views/bidding/views/project-flow/ping/pbzb/list'),
            meta: {
                title: '评标准备列表',
                bread: B_1
            },
        }
    ]
}